import { connect } from 'react-redux';
import ParticipantDetailsComponent from '../components/participant_details';
import ParticipantsActions from '../actions/participants';

function mapStateToProps(state, props) {

  const user = props.user;
  const userSlug = user ? user.slug : null;
  const storeHasDetails = state.participants.detailsBySlug.hasOwnProperty(userSlug);

  if (storeHasDetails) {
    Object.assign(user, state.participants.detailsBySlug[userSlug], {hasDetailsFromStore: true});
  }

  return {
    user: user
  };
}

const ParticipantDetailsContainer = connect(
  mapStateToProps,
  {
    fetchUserDetails: ParticipantsActions.fetchUserDetails
  }
)(ParticipantDetailsComponent);

export default ParticipantDetailsContainer;
